const {
  physicalAssessmentLocationLabel,
  ivSiteLabel,
} = require('~lib/common/utils/labels');
import makeMoulageLabel from '~lib/common/utils/makeMoulageLabel';

const invalidMoulageRules = {
  LEFT: [
    {
      disabledIvSites: [
        'IV_ANTECUBITAL',
        'IO_HUMERUS',
        'IV_FOREARM',
        'IV_HAND',
      ],
      triggeringLocation: 'LEFT_ARM_UPPER',
      triggeringMoulages: [
        'FRACTURE_CLOSED_UPPER',
        'AMPUTATION_CLEAN_UPPER',
        'AMPUTATION_MESSY_UPPER',
        'AMPUTATION_BLAST_UPPER',
      ],
    },
    {
      disabledIvSites: ['IV_FOREARM', 'IV_HAND'],
      triggeringLocation: 'LEFT_ARM_LOWER',
      triggeringMoulages: [
        'FRACTURE_CLOSED_LOWER',
        'AMPUTATION_CLEAN_LOWER',
        'AMPUTATION_MESSY_LOWER',
        'AMPUTATION_BLAST_LOWER',
      ],
    },
    {
      disabledIvSites: ['IV_HAND'],
      triggeringLocation: 'LEFT_HAND',
      triggeringMoulages: [
        'FRACTURE_CLOSED_EXTREMITY',
        'AMPUTATION_CLEAN_EXTREMITY',
        'AMPUTATION_MESSY_EXTREMITY',
        'AMPUTATION_BLAST_EXTREMITY',
      ],
    },
    {
      disabledIvSites: ['IO_DISTAL_FEMUR', 'IO_PROXIMAL_TIBIA', 'IO_DISTAL_TIBIA', 'IV_FOOT'],
      triggeringLocation: 'LEFT_LEG_UPPER',
      triggeringMoulages: [
        'FRACTURE_CLOSED_UPPER',
        'AMPUTATION_CLEAN_UPPER',
        'AMPUTATION_MESSY_UPPER',
        'AMPUTATION_BLAST_UPPER',
      ],
    },
    {
      disabledIvSites: ['IO_PROXIMAL_TIBIA', 'IO_DISTAL_TIBIA', 'IV_FOOT'],
      triggeringLocation: 'LEFT_LEG_LOWER',
      triggeringMoulages: [
        'FRACTURE_CLOSED_LOWER',
        'AMPUTATION_CLEAN_LOWER',
        'AMPUTATION_MESSY_LOWER',
        'AMPUTATION_BLAST_LOWER',
      ],
    },
    {
      disabledIvSites: ['IV_FOOT'],
      triggeringLocation: 'LEFT_FOOT',
      triggeringMoulages: [
        'FRACTURE_CLOSED_EXTREMITY',
        'AMPUTATION_CLEAN_EXTREMITY',
        'AMPUTATION_MESSY_EXTREMITY',
        'AMPUTATION_BLAST_EXTREMITY',
      ],
    },
  ],
  RIGHT: [
    {
      disabledIvSites: [
        'IV_ANTECUBITAL',
        'IO_HUMERUS',
        'IV_FOREARM',
        'IV_HAND',
      ],
      triggeringLocation: 'RIGHT_ARM_UPPER',
      triggeringMoulages: [
        'FRACTURE_CLOSED_UPPER',
        'AMPUTATION_CLEAN_UPPER',
        'AMPUTATION_MESSY_UPPER',
        'AMPUTATION_BLAST_UPPER',
      ],
    },
    {
      disabledIvSites: ['IV_FOREARM', 'IV_HAND'],
      triggeringLocation: 'RIGHT_ARM_LOWER',
      triggeringMoulages: [
        'FRACTURE_CLOSED_LOWER',
        'AMPUTATION_CLEAN_LOWER',
        'AMPUTATION_MESSY_LOWER',
        'AMPUTATION_BLAST_LOWER',
      ],
    },
    {
      disabledIvSites: ['IV_HAND'],
      triggeringLocation: 'RIGHT_HAND',
      triggeringMoulages: [
        'FRACTURE_CLOSED_EXTREMITY',
        'AMPUTATION_CLEAN_EXTREMITY',
        'AMPUTATION_MESSY_EXTREMITY',
        'AMPUTATION_BLAST_EXTREMITY',
      ],
    },
    {
      disabledIvSites: ['IO_DISTAL_FEMUR', 'IO_PROXIMAL_TIBIA', 'IO_DISTAL_TIBIA', 'IV_FOOT'],
      triggeringLocation: 'RIGHT_LEG_UPPER',
      triggeringMoulages: [
        'FRACTURE_CLOSED_UPPER',
        'AMPUTATION_CLEAN_UPPER',
        'AMPUTATION_MESSY_UPPER',
        'AMPUTATION_BLAST_UPPER',
      ],
    },
    {
      disabledIvSites: ['IO_PROXIMAL_TIBIA', 'IO_DISTAL_TIBIA', 'IV_FOOT'],
      triggeringLocation: 'RIGHT_LEG_LOWER',
      triggeringMoulages: [
        'FRACTURE_CLOSED_LOWER',
        'AMPUTATION_CLEAN_LOWER',
        'AMPUTATION_MESSY_LOWER',
        'AMPUTATION_BLAST_LOWER',
      ],
    },
    {
      disabledIvSites: ['IV_FOOT'],
      triggeringLocation: 'RIGHT_FOOT',
      triggeringMoulages: [
        'FRACTURE_CLOSED_EXTREMITY',
        'AMPUTATION_CLEAN_EXTREMITY',
        'AMPUTATION_MESSY_EXTREMITY',
        'AMPUTATION_BLAST_EXTREMITY',
      ],
    },
  ],
};

function getSiteInvalidityMessage(side, siteKey, selectedMoulages) {
  const rules = invalidMoulageRules[side];
  if (!rules) {
    return false;
  }

  for (const rule of rules) {
    if (
      rule.disabledIvSites.includes('ANY') ||
      rule.disabledIvSites.includes(siteKey)
    ) {
      const otherMoulage = selectedMoulages[rule.triggeringLocation];
      if (otherMoulage) {
        if (
          rule.triggeringMoulages.includes('ANY') ||
          rule.triggeringMoulages.includes(otherMoulage)
        ) {
          return (
            rule.message ||
            `IV not available on the ${ivSiteLabel(
              siteKey
            )} site when ${makeMoulageLabel(
              otherMoulage
            )} is present on ${physicalAssessmentLocationLabel(
              rule.triggeringLocation
            )}`
          );
        }
      }
    }
  }
}

export default getSiteInvalidityMessage;
